import { useEffect, useState } from "react";
import { api } from "./api";

const STORAGE_KEY = "bb_geo_country_v1";

/**
 * Returns the visitor's ISO-2 country code, cached in localStorage so we don't
 * hit /api/geo on every page render. Defaults to empty string before the API
 * answers — callers (e.g. pinkPriceLabel) treat empty/unknown as ROW ($40 USD)
 * to avoid mis-pricing Egyptian / international visitors as Gulf (AED).
 */
export function useGeo() {
  const [country, setCountry] = useState(() => {
    try {
      return window.localStorage.getItem(STORAGE_KEY) || "";
    } catch (_) {
      return "";
    }
  });

  useEffect(() => {
    let cancelled = false;
    api
      .get("/geo")
      .then((r) => {
        const cc = (r.data?.country || "").toUpperCase();
        if (!cancelled && cc && cc !== "XX" && cc.length === 2) {
          setCountry(cc);
          try {
            window.localStorage.setItem(STORAGE_KEY, cc);
          } catch (_) { /* ignore */ }
        }
      })
      .catch(() => { /* keep fallback */ });
    return () => {
      cancelled = true;
    };
  }, []);

  return country;
}
